if (!customElements.get('tabs-distributors')) {
  class TabsDistributors extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.tabPanels = [];
      this.firstTab = null;
      this.lastTab = null;
    }

    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[tabs-distributors="tab"]')];

      this.tabs.forEach(tab => {
        const tabPanel = document.getElementById(tab.getAttribute('aria-controls'));

        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');
        this.tabPanels.push(tabPanel);

        tab.addEventListener('keydown', this.handleKeydown.bind(this));
        tab.addEventListener('click', this.handleClick.bind(this));

        if (!this.firstTab) {
          this.firstTab = tab;
        }
        this.lastTab = tab;
      })

      this.setSelectedTab(this.firstTab, false);
    }

    setSelectedTab(currentTab, setFocus) {
      if (typeof setFocus !== 'boolean') {
        setFocus = true;
      }

      this.tabs.forEach((tab, i) => {
        if (currentTab === tab) {
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');
          tab.classList.add('is-active');
          this.tabPanels[i].classList.remove('is-hidden');
          if (setFocus) {
            tab.focus();
          }
          return;
        }

        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        tab.classList.remove('is-active');
        this.tabPanels[i].classList.add('is-hidden');
      })
    }

    setSelectedToPreviousTab(currentTab) {
      if (currentTab === this.firstTab) {
        return this.setSelectedTab(this.lastTab);
      }

      const index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }

    setSelectedToNextTab(currentTab) {
      if (currentTab === this.lastTab) {
        return this.setSelectedTab(this.firstTab);
      }

      const index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }

    handleKeydown(event) {
      const target = event.currentTarget
      let flag = false;

      switch (event.key) {
        case 'ArrowLeft':
          this.setSelectedToPreviousTab(target);
          flag = true;
          break;

        case 'ArrowRight':
          this.setSelectedToNextTab(target);
          flag = true;
          break;

        case 'Home':
          this.setSelectedTab(this.firstTab);
          flag = true;
          break;

        case 'End':
          this.setSelectedTab(this.lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    handleClick(event) {
      this.setSelectedTab(event.target);
    }
  }

  customElements.define('tabs-distributors', TabsDistributors);
}
